import { Button, Stack } from '@mui/material';
import { useLocale } from 'hooks';
import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const languages = [
  { code: 'en', label: 'English', shortLabel: 'EN' },
  { code: 'zh-Hant', label: '繁體中文', shortLabel: '䌓' },
  { code: 'zh-Hans', label: '简体中文', shortLabel: '简' },
];

function LanguageSwitcher({ size = 'small' }) {
  const locale = useLocale();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleChange = useCallback((newLocale) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('locale', newLocale);

    // Navigate to the same page with new locale
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  }, [location.pathname, searchParams, navigate]);

  return (
    <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
      {languages.map((lang) => (
        <Button
          key={lang.code}
          size={size}
          variant={locale === lang.code ? 'contained' : 'outlined'}
          onClick={() => handleChange(lang.code)}
          sx={{
            minWidth: 'unset',
            padding: '4px 8px',
            fontWeight: locale === lang.code ? 'bold' : 'normal',
            color: locale === lang.code ? 'primary.contrastText' : 'primary',
            backgroundColor: locale === lang.code ? 'primary.main' : 'transparent',
            '&:hover': {
              backgroundColor: locale === lang.code ? 'primary.dark' : 'action.hover',
            },
          }}
        >
          {lang.shortLabel}
        </Button>
      ))}
    </Stack>
  );
}

export default LanguageSwitcher;
